import React, { useEffect, useState } from "react";
import "../../Client/Client.css";
import logo from "../../../assets/img/logo.png"; // Adjust path as neededimport CommonFooter from "../CommonLayout/CommonFooter";
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientSidebar from "../ClientLayout/ClientSidebar";
import ClientFooter from "../ClientLayout/ClientFooter";
import { Link } from "react-router-dom";
import { API_URL } from "../../../Constant.js";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap"

const ClientCounsellorList = () => {

  const [counsellorList, setCounsellorList] = useState([]);
  const navigate = useNavigate();
  const [selectedCounsellingTypeId, setSelectedCounsellingTypeId] = useState("");

  useEffect(() => {
    fetchCounsellorList();
  }, [selectedCounsellingTypeId]);

  const fetchCounsellorList = async () => {
    try {
      const response = await fetch(
        API_URL + "api/Counsellor/GetCounsellorList"
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      // alert("Fetched Counsellor List:"+ JSON.stringify(data));

      if (data && Array.isArray(data.data)) {


        const counsellingFieldMap = {
          "1": "isIndividualCounselling",
          "2": "isCoupleCounselling",
          "3": "isFamilyCounselling"
        };

        if (selectedCounsellingTypeId && counsellingFieldMap[selectedCounsellingTypeId]) {
          const field = counsellingFieldMap[selectedCounsellingTypeId];
          var FiltData = data.data.filter(counsellor => counsellor[field] === "True");
          setCounsellorList(FiltData);
        }
        else {
          setCounsellorList(data.data);
        }

      } else {
        console.error("Invalid API response format:", data);
        setCounsellorList([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Phases:", error);
    }
  };

  const handleBookAppointment = (counsellorId) => {

    navigate(`/client/availability/${counsellorId}`);

  };

  const handleCounsellingTypeChange = (e) => {
    setSelectedCounsellingTypeId(e.target.value);
  };

  return (
    <div>
      <ClientNavbar />
      <br />
      <center>
        <h2>Counsellors</h2>
      </center>
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          textAlign: "left",
        }}
      >

        <label>Select Counselling Type :</label>
        <select
          className="form-control"
          style={{ width: "250px" }}
          value={selectedCounsellingTypeId}
          onChange={handleCounsellingTypeChange}
        >
          <option value={0}>ALL</option>
          <option key={1} value={1} >
            Individual
          </option>
          <option key={2} value={2} >
            Couple
          </option>
          <option key={3} value={3} >
            Family
          </option>
        </select>
      </div>

      {/* Flexbox for 4 Cards in a Row */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          textAlign: "center",
        }}
      >

        {counsellorList.map((counsellor, index) => (
          <div
            key={index}
            className="card"
            style={{ width: "20rem", borderRadius: "10px" }}
          >
            <div className="row">
              <div className="col-md-4" style={{ paddingLeft: "25px" }}>
                <img
                  src={
                    counsellor.profilePictureUrl
                      ? `${API_URL}api/Login/GetImageByImageURL/${counsellor.profilePictureUrl.replace(
                        "images/",
                        ""
                      )}`
                      : null
                  }
                  alt="User"
                  style={{
                    width: "80px",
                    height: "80px",
                  }}
                  onError={(e) => {
                    console.log("Image load error:", e);
                    e.target.onerror = null; // Prevent infinite loop
                  }}
                />
              </div>

              <div
                className="col-md-8"
                style={{ textAlign: "left", padding: "25px", verticalAlign: "center" }}
              >
                <h5 className="p-0 m-0">{counsellor.counsellorName}</h5>
              </div>
            </div>
            <hr />

            <div className="card-body">
              <strong>Counselling Type </strong>
              <br />
              <b style={{ color: "rgb(40, 143, 253)" }}>
                {counsellor.isIndividualCounselling && counsellor.isIndividualCounselling !== "False" && "Individual  "}
                {counsellor.isCoupleCounselling && counsellor.isCoupleCounselling !== "False" && "Couple  "}
                {counsellor.isFamilyCounselling && counsellor.isFamilyCounselling !== "False" && "Family"}
              </b>

              <br />
              <br />
              <strong>Expertise </strong>
              <br />
              <b style={{ color: "rgb(40, 143, 253)" }}>
                {counsellor.expertise}
              </b>
              <br />
              <br />
              <strong>Languages</strong>
              <br />
              <b style={{ color: "rgb(40, 143, 253)" }}>
                {counsellor.language}
              </b>
              <br />
              <br />
              <label style={{ alignItems: "center", gap: "30px" }}>
                <b>Duration :</b>&nbsp;60 Min
              </label>

              <br />
              <label>
                <b>Fees :</b> {counsellor.individualCounsellingFirst} $
              </label>
              <br />
              <Link to={`/client/ClientCounsellorProfile/${counsellor.loginId}`}>
                <b>View Profile</b>
              </Link>
              <p className="card-text"></p>
              <button type="button" className="btn btn-primary" onClick={() => handleBookAppointment(counsellor.loginId)}>
                Book Appointment
              </button>
            </div>
          </div>
        ))}



      </div>

      <br />
      <br />
      <br />
      {/* <div style={{textAlign:"center"}} className="mt-4 mb-4 pb-4">
              
          
              <Button  variant="secondary" size="lg" onClick={() => navigate(-1)}>
                Previous
              </Button>
              </div> */}
      <ClientFooter />
    </div>
  );
};

export default ClientCounsellorList;
